import type { PrioritisationT as HundredPointsT } from '@mentimeter/question-modules-types';
import { useTranslations } from 'next-intl';

interface ScreenReaderTableProps {
  results: HundredPointsT['results'];
  shouldHideResults: boolean;
}

export const ScreenReaderTable = ({
  results,
  shouldHideResults,
}: ScreenReaderTableProps) => {
  const translate = useTranslations('presenting.screenreader_table');

  if (shouldHideResults) {
    return <span>{translate('results_are_hidden_message')}</span>;
  }

  const sortedResults = results.sort((a, b) => b.score - a.score);

  return (
    <table>
      <caption>{translate('results_table_caption')}</caption>
      <thead>
        <tr>
          <th scope="col">{translate('option_column_title')}</th>
          <th scope="col">{translate('points_column_title')}</th>
        </tr>
      </thead>
      <tbody>
        {sortedResults.map((result) => {
          return (
            <tr key={result.id}>
              <th scope="row">{result.label}</th>
              <td>{Math.round(result.score)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
